import React, { useEffect, useState } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import Login from './Components/Auth/Login';
import Register from './Components/Auth/Register';
import Profile from './Components/Profile';
import AdminDashboard from './Components/Admin/AdminDashboard';
import Settings from './Components/Dashboard/Settings';
import RewardsPage from './Pages/Reward';
import CollectionPointsPage from './Pages/CollectionPointPage';
import RegisterStaff from './Components/CollectionStaff/RegisterStaff';
import LoginStaff from './Components/CollectionStaff/LoginStaff';
import StaffDashboard from './Components/CollectionStaff/StaffDashboard';
import LandingPage from './Pages/LandingPage';
import Esave from './Components/Esave';
import FullPageMap from './Components/FullPageMap';
import ToastContainer from './Components/Toast';
import { startKeepAlive } from './Services/keepAlive';

function App() {
  const [isAuthenticated, setIsAuthenticated] = useState(!!localStorage.getItem('token'));
  const [isAuthenticatedStaff, setIsAuthenticatedStaff] = useState(!!localStorage.getItem('staff-token'));

  useEffect(() => {
    setIsAuthenticated(!!localStorage.getItem('token'));
    setIsAuthenticatedStaff(!!localStorage.getItem('staff-token'));
    startKeepAlive();
  }, []);

  return (
    <div className="App">
      <ToastContainer />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/rewards" element={<RewardsPage />} />
        <Route path="/collection-points" element={<CollectionPointsPage />} />
        <Route path="/staff-login" element={<LoginStaff />} />
        <Route path="/staff-register" element={<RegisterStaff />} />
        <Route path="/test" element={<Esave />} />
        <Route path='/map' element={<FullPageMap />} />

        <Route
          path="/staff-dashboard"
          element={isAuthenticatedStaff ? <StaffDashboard /> : <Navigate to="/staff-login" />}
        />
        <Route path="/" element={<LandingPage />} />

        <Route
          path="/profile"
          element={isAuthenticated ? <Profile /> : <Navigate to="/login" />}
        />
        <Route
          path="/settings"
          element={isAuthenticated ? <Settings /> : <Navigate to="/login" />}
        />

        <Route
          path="/admin"
          element={isAuthenticated && localStorage.getItem('role') === 'admin' ? <AdminDashboard /> : <Navigate to="/login" />}
        />

        <Route path="*" element={<Navigate to="/login" />} />
      </Routes>
    </div>
  );
}

export default App;
